/**
 * @name BannerExtension.View.js
 * 
 * @author Anchor Group : Jack Steiner <jsteiner@anchorgroup.tech>
 *
 * @since 2025-11-17
 * 
 * @file Create Banner to display versapay disclaimer.
 * 
 */
define('AnchorGroup.BannerExtension.BannerExtension.View'
,	[
	'anchorgroup_bannerextension_bannerextension.tpl'
	
	,	'Backbone'
    ]
, function (
	anchorgroup_bannerextension_bannerextension_tpl
	
	,	Backbone
)
{
    'use strict';

	return Backbone.View.extend({

		template: anchorgroup_bannerextension_bannerextension_tpl

	,	initialize: function (options) {
		_.extend(this, options)
		}

	,	getContext: function getContext()
		{
			return {
				topText: this.topText,
				bottomText: this.bottomText,
				versapayLink: this.versapayLink
			}
		}
	});
});
